<div style="overflow-y: scroll; background-color: var(--white);">
  <div class="list-group">
    <div *ngFor="let group of groupedTags; let i = index">
      <!-- Parent Category -->
      <button class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" (click)="closeAll(); visisbleGroups[i] = !visisbleGroups[i]; currentGroup = group[0][0]" role="button" aria-expanded="false" style="font-weight: bold">
        {{ group[0][0]  }}
        <i class="fas fa-chevron-down"></i>
      </button>

      <!-- Child Tags (Collapsible) -->
      <div *ngIf="visisbleGroups[i]" class="d-flex mt-2 mb-2" style="flex-wrap: wrap">
        <button style="cursor: pointer" *ngFor="let tag of group[0][1]" class="btn btn-outline-primary btn-sm mr-2 mb-2 tag" (click)="addTagToProduct(tag[0], tag[1])" [class.active]="tag[2]">
          {{ tag[0] | titlecase }}
          <i *ngIf="isAdmin()" class="fas fa-x text-primary clickable" (click)="$event.stopPropagation(); deleteTag(tag[0])"></i>
        </button>

        <div class="d-flex justifiy-content-center align-items-center w-100 mt-2 mb-2 collar">
          <input [(ngModel)]="newTagName" class="form-control mr-2" style="width: 16em" placeholder="New Tag Name" />

          <button (click)="addTagToProduct(newTagName, groupMaps[currentGroup])" class="my-button-3" style="height: 100%; font-size: 0.8em"><i class="fa fa-info"></i> Suggest</button>
        </div>
      </div>
    </div>
  </div>
</div>
